import { Badge } from "@/components/ui/Badge";
import { OFFICIAL_FEE_STATUS_COLORS, OFFICIAL_FEE_STATUS_LABELS, type OfficialFeeStatus } from "../types";

interface Props {
  status: OfficialFeeStatus;
}

export function OfficialFeeStatusBadge({ status }: Props) {
  return (
    <Badge color={OFFICIAL_FEE_STATUS_COLORS[status]}>
      {OFFICIAL_FEE_STATUS_LABELS[status]}
    </Badge>
  );
}
